import React, { useState, useRef, useEffect } from 'react'
import './index.less'
import { Popup, PickerView } from '@xp-design/mobile';
import { trackGdp } from '../../../../utils/gio-report';

interface MileageListDataRule {
    label: string;
    value: string;
}

const mileageColumns: any[] = [
    [
        { value: '0.1', label: '0.1 元/度' },
        { value: '0.2', label: '0.2 元/度' },
        { value: '0.3', label: '0.3 元/度' },
        { value: '0.4', label: '0.4 元/度' },
        { value: '0.5', label: '0.5 元/度' },
        { value: '0.6', label: '0.6 元/度' },
        { value: '0.7', label: '0.7 元/度' },
        { value: '0.8', label: '0.8 元/度' },
        { value: '0.9', label: '0.9 元/度' },
        { value: '1.0', label: '1.0 元/度' },
        { value: '1.1', label: '1.1 元/度' },
        { value: '1.2', label: '1.2 元/度' },
        { value: '1.3', label: '1.3 元/度' },
        { value: '1.4', label: '1.4 元/度' },
        { value: '1.5', label: '1.5 元/度' },
        { value: '1.6', label: '1.6 元/度' },
        { value: '1.7', label: '1.7 元/度' },
        { value: '1.8', label: '1.8 元/度' },
        { value: '1.9', label: '1.9 元/度' },
    ],
];

interface PropsRule {
    onChange: (value: string) => void
    price?: string
    orderNo: string
    type: string
}

const SharePilePriceSelector = (props: PropsRule) => {
    const { onChange, price, orderNo, type } = props
    const [visible, setVisible] = useState<boolean>(false)
    const temp = useRef<any>(mileageColumns[0][0].value)
    const [actualSelected, setActualSelected] = useState<MileageListDataRule>(mileageColumns[0][0] as any)
    useEffect(() => {
        if (price) {
            let matchPrice = mileageColumns[0].find(i => i.value === price)
            if (matchPrice) {
                setActualSelected(matchPrice)
            }
        }
    }, [price])
    return <>
        <div
            className='pileSharePriceInfo'
            onClick={
                (e) => {
                    setVisible(true)
                    trackGdp('P20224', 'B005', {
                        orderNo: orderNo,
                        element_type: type
                    })
                }
            }
        >
            <div className='label'>{actualSelected.label}</div>
            <img className='icon' src='https://s.xiaopeng.com/xp-charge/charge/pile-apply/edit.png' alt="" />
        </div>
        <Popup
            visible={visible}
            onMaskClick={() => {
                setVisible(false);
            }}
            onClose={() => {
                setVisible(false);
            }}
            bodyStyle={{ height: '40vh' }}
        >
            <div className='sharePilePriceWrap'>
                <img className='closeIcon' src={'https://s.xiaopeng.com/xp-charge/charge/charge-system/close_icon.svg'} alt='' onClick={() => setVisible(false)} />
                <div className='title'>选择价格</div>
                <div className='content'>
                    <PickerView
                        style={{ '--height': '524px', '--item-height': '80px' }}
                        columns={mileageColumns}
                        onChange={item => {
                            console.log(item)
                            temp.current = item[0]
                        }}
                    />
                </div>
                <div className='sharePilePriceSelectBtn' onClick={() => {
                    setActualSelected(mileageColumns[0].find(i => i.value === temp.current) as any)
                    onChange(mileageColumns[0].find(i => i.value === temp.current).value)
                    setVisible(false)
                }}>
                    确定
                </div>
            </div>
        </Popup >
    </>
}

export default SharePilePriceSelector